import { Link } from "react-router-dom";
import { styled, Tooltip } from "@monolith-forensics/monolith-ui";
import { User, Users } from "lucide-react";
import { Office } from "../offices.types";

interface OfficesItemProps {
  className?: string;
  office: Office;
}

export const OfficesItem = styled(({ className, office }: OfficesItemProps) => {
  let addressBlock = "";
  if (office.office_city) addressBlock += office.office_city;
  if (office.office_region) {
    addressBlock += addressBlock !== "" ? ", " : "";
    addressBlock += office.office_region;
  }
  if (!addressBlock) addressBlock = "No Location";

  let manager = office?.manager?.full_name || "No Manager";

  return (
    <div className={className}>
      <Link to={`/offices/${office.office_id}`}>
        <div className="office-item-container">
          <div
            className="office-header"
            title={office?.office_name || "Office"}
          >
            {office.office_name}
          </div>
          <div className="office-content">{addressBlock}</div>
          <div className="office-footer">
            <Tooltip
              content={`${
                office.manager?.title ? `Title: ${office.manager.title}` : ""
              }${
                office.manager?.email
                  ? `${office.manager?.title ? "\n" : ""}Email: ${
                      office.manager.email
                    }`
                  : ""
              }`}
              delayDuration={600}
            >
              <div className="footer-item">
                <User size={14} />
                <div>{manager}</div>
              </div>
            </Tooltip>
            <div className="footer-item" title="Total users at this office">
              <Users size={14} />
              <div>{office?.total_users || 0}</div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
})`
  & {
    position: relative;
    width: 400px;
    height: 120px;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .office-item-container {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 5px;
    transition: all 0.2s ease-in-out;
    &:hover {
      background-color: ${({ theme }) => theme.palette.action.hover};
    }
  }

  .office-header {
    font-size: 20px;
    width: fit-content;
    max-width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .office-content {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 11px;
  }

  .office-footer {
    position: absolute;
    bottom: 10px;
    display: flex;
    align-items: center;
    align-content: center;
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 11px;
    svg {
      font-size: 16px;
      margin-right: 3px;
    }

    .footer-item {
      display: flex;
      align-items: center;
      align-content: center;
      margin-right: 15px;
      &:hover {
        color: ${({ theme }) => theme.palette.text.primary};
      }
    }
  }
`;
